// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"d27af042","334":"d9014781","453":"19209787","479":"11bc1627","492":"9cfce570","745":"2a6d0cff","886":"1f9424f2","923":"5613b8ed"}[chunkId] + ".chunk.js";
};